import moment from 'moment';

// Adds formatted labels and sorts by timestamp
export const enrichAndSortData = (data) => {
  const enriched = data.map((item) => {
    const fullDate = moment(item.sentDate).set('hour', item.sentHour);

    const label = fullDate.format('HH:00 MMM DD');
    return {
      ...item,
      label,
      timestamp: fullDate.valueOf(),
    };
  });

  enriched.sort((a, b) => a.timestamp - b.timestamp);

  return enriched;
};

// Extracts array of labels from the data
export const getLabels = (data) => [...new Set(data.map((e) => e.label))];

// Returns options for the X-axis with date string formatting
export const getXAxisDateTimeOptions = (labels) => [
  {
    scaleType: 'point',
    data: labels,
    tickLabelStyle: {
      fontSize: 10,
    },
    valueFormatter: (date, context) =>
      context.location === 'tick' ? `${date.replace(' ', '\n')}` : `${date}`,
  },
];

export const NumberCompactFormatter = new Intl.NumberFormat('en-US', {
  notation: 'compact',
  compactDisplay: 'short',
});
